var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    className: "_dm-svg",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.785 1.498l2.717 2.716 1.019-1.018.338-.34a.48.48 0 000-.68L13.824.142a.482.482 0 00-.68-.001l-.34.34-.678.679-.34.339zm-.82.82l-8.546 8.547 2.716 2.716 8.546-8.546-2.716-2.716zm-9.369 9.369L.023 15.782c-.068.174.02.261.194.194l4.095-1.573-2.716-2.716z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/EditPencil.d38376df7355bdbf8d0bf348671b2729.svg";
export { ForwardRef as ReactComponent };